import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getTypeConfigurationActionAsync } from '../redux/actions/typeConfigurationActions'

export const useTypeConfiguration = () => {
  const { typeConfigurationState } = useSelector(
    (state: RootState) => state.typeConfiguration
  )
  const dispatch = useDispatch()

  const getTypeConfiguration = () => {
    dispatch(getTypeConfigurationActionAsync())
  }

  return { typeConfigurationState, getTypeConfiguration }
}
